import React from "react";
import RandomFloating from "../../common/components/RandomFloating";

const CircleCard = ({ children, className = "" }) => {
  return (
    <RandomFloating className={`${className} w-fit absolute`}>
      <div
        className={`size-[110px] sm:size-[128px] lg:size-[158px] xl:size-[178px] rounded-full border-[3.3px] border-solid border-custom-blue-v2 bg-white relative after:absolute after:top-0 after:left-0 after:h-full after:w-full after:rounded-full after:bg-custom-blue-v2/10 after:z-0 after:pointer-events-none flex justify-center items-center hover:after:bg-custom-blue-v2/90 group cursor-pointer p-2 lg:p-4`}>
        <h2 className="font-bold !leading-150 text-custom-black text-xs sm:text-sm md:text-base xl:text-lg text-center group-hover:text-white relative z-20">
          {children}
        </h2>
      </div>
    </RandomFloating>
  );
};

export default CircleCard;
